import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import tangent_svg from '../../../assets/img/SVG_icons/Top/editing_model/edit_edge_tangent_at_vertex.svg';
import { img } from '@phi/components';
import { enter_editing_edge_tangent_mode, exit_editing_edge_tangent_mode } from '@frontend/ui_display';
import TangentTooltip from './TangentTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const TangentIcon = tangent_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Edit Tangents';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else if (this.state.editing_edge_tangent_mode)
                exit_editing_edge_tangent_mode();
            else
                enter_editing_edge_tangent_mode();
        },
    },

    render() {
        return h(BarButton, {
            id: 'edit-edge-tangent-mode-button',
            wrapperId: 'edit-edge-tangent-mode-wrapper',
            active: this.state.editing_edge_tangent_mode,
            disabled: this.disabled,
            selected: this.state.tut_stage === 8,
            tippy: 'left',
            onClick: this.onClick,
            help: 'manage_tangents_mode',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            label: () => 'Tangent',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(tangent_svg, this.alt),
            tooltip: TangentTooltip,
        });
    },
});
